module.exports = __webpack_public_path__ + "img/undraw_Nature_fun_re_iney.fcb59179.svg";